getConfirmation